const APP_SRC = "https://www.gstatic.com/firebasejs/10.14.1/firebase-app-compat.js";
const AUTH_SRC = "https://www.gstatic.com/firebasejs/10.14.1/firebase-auth-compat.js";

function loadScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Could not load Firebase. Check your connection and try again."));
    document.head.appendChild(script);
  });
}

let sdkReady = null;

async function authFor(config) {
  if (!sdkReady) {
    sdkReady = (async () => {
      await loadScript(APP_SRC);
      await loadScript(AUTH_SRC);
    })();
  }
  await sdkReady;
  const firebase = window.firebase;
  if (!firebase) throw new Error("Firebase did not load.");
  const name = `otp-${config.projectId}`;
  const existing = (firebase.apps || []).find((app) => app.name === name);
  const app = existing || firebase.initializeApp({
    apiKey: config.apiKey,
    authDomain: config.authDomain,
    projectId: config.projectId,
    appId: config.appId,
    messagingSenderId: config.messagingSenderId,
    ...(config.storageBucket ? { storageBucket: config.storageBucket } : {}),
  }, name);
  return { app, auth: firebase.auth(app) };
}

export function toE164(local, dial = "91") {
  const digits = String(local || "").replace(/\D/g, "");
  const cc = String(dial || "91").replace(/\D/g, "") || "91";
  if (digits.length < 8 || digits.length > 15) return "";
  if (digits.startsWith(cc) && digits.length > 10) return `+${digits}`;
  return `+${cc}${digits}`;
}

export async function sendFirebaseOtp(config, phoneE164, container) {
  const { app, auth } = await authFor(config);
  const firebase = window.firebase;
  if (container._verifier) {
    try { container._verifier.clear(); } catch { /* recaptcha already gone */ }
  }
  container.innerHTML = "";
  // The third argument is the Firebase app. Passing auth makes the SDK read a missing apiKey and throw auth/invalid-api-key.
  const verifier = new firebase.auth.RecaptchaVerifier(container, { size: "normal" }, app);
  container._verifier = verifier;
  const confirmation = await auth.signInWithPhoneNumber(phoneE164, verifier);
  return confirmation;
}
